module.exports = __webpack_public_path__ + "static/dunkin-1_PLACEHOLDER-87650bbb87cd048cdd07571a1400ae2f.jpg";